import { useTranslation } from "react-i18next";
import classNames from "classnames";
import { SecondaryBody } from "./typography";
import type { StageStatus } from "./application_stage_marker";
import ApplicationStageMarker from "./application_stage_marker";

const STAGES: { key: string; status: StageStatus }[] = [
  { key: "initial_screen", status: "completed" },
  { key: "team_interview", status: "completed" },
  { key: "onsite_interview", status: "current" },
  { key: "offer", status: "upcoming" },
];

const ApplicationStages = () => {
  const { t } = useTranslation("job_post");

  return (
    <div className="application_tracking_widget__stages">
      {STAGES.map(({ key, status }, index) => {
        const isLast = index === STAGES.length - 1;

        return (
          <div className="application_tracking_widget__stages__row" key={key}>
            <div className="application_tracking_widget__stages__marker">
              <ApplicationStageMarker status={status} />
              {!isLast && (
                <span
                  className={classNames("application_tracking_widget__stages__connector", {
                    "application_tracking_widget__stages__connector--complete":
                      status === "completed",
                  })}
                />
              )}
            </div>
            <div
              className={classNames("application_tracking_widget__stages__label", {
                "application_tracking_widget__stages__label--last": isLast,
                "application_tracking_widget__stages__label--upcoming": status === "upcoming",
              })}
            >
              <SecondaryBody medium={status === "current"}>
                {t(`application_tracking_widget.stages.${key}`)}
              </SecondaryBody>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ApplicationStages;
